import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Card, Descriptions, Divider, Tag, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

import "./programDetail.scss";
import ApplicationList from "../applicationList/applicationList";
import { programDetail, template } from "../../../apis/admin";
import { replaceUrlByParams } from "../../../utils/api";
import { PAGE } from "../../../utils/constants";
import { AppContext } from "../../../App";
import ImportExportSection from "../../../components/importExportSection/importExportSection";
import { paymentMethodText } from "../../../components/paymentStatusTemplate/paymentStatusTemplate";

// import ApplicationList from "../applicationList/applicationList";

function ProgramDetail() {
  const { pid } = useParams();
  const { Text } = Typography;

  const [programData, setProgramData] = useState({
    paymentMethod: [],
  });

  const [sectionIdOption, setSectionIdOption] = useState({
    importExport: {},
    importResult: {},
  });

  const { setLoading } = useContext(AppContext);
  useEffect(() => {
    getProgramDetail();
    getApplicationSectionId();
    // eslint-disable-next-line react-hooks/exhaustive-deps,
  }, []);

  const getProgramDetail = async () => {
    setLoading(true);
    try {
      const res = await programDetail(pid);
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setProgramData({
          ...programData,
          title: res.configuration.title,
          description: res.configuration.description,
          maxApplicationCount: res.configuration.maxApplicationCount,
          applicationCount: res.configuration.applicationCount,
          logo: res.configuration.logo,
          image: res.configuration.image,
          language: res.configuration.language,
          enrolButton: res.configuration.enrolButton,
          activated: res.configuration.activated,
          deactivatedMsg: res.configuration.deactivatedMsg,
          payment: res.configuration.payment.enabled,
          paymentMethod: res.configuration.payment.paymentMethod,
          resultForm: res.configuration.checkResult.name,
          // fields: res.configuration.checkResult.fields.map((field) => {
          //     return {
          //         id: field.id,
          //         name: field.name,
          //         type: field.type,
          //         optional: field.optional
          //
          //     }
          // }),
          resultSubmitButton: res.configuration.checkResult.submitButton,
          enrolmentEnabled: res.configuration.enrolmentEnabled,
          enrolmentDisabledMsg: res.configuration.enrolmentDisabledMsg,
          applicationSuccessTitle: res.configuration.applicationSuccess.title,
          applicationSuccessDescription:
            res.configuration.applicationSuccess.description,
          receiptWaterMark: res.configuration.receipt.backgroundLogo,
          receiptRemarks: res.configuration.receipt.remarks,
          receiptFooter: res.configuration.receipt.footer,
          referenceId: res.configuration.referenceId,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const getApplicationSectionId = async () => {
    try {
      const res = await template(pid); //admin template
      if (res.error) {
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setSectionIdOption(
          res.reduce((acc, curr) => {
            return {
              ...acc,
              importExport: curr.enableImport
                ? {
                    ...acc.importExport,
                    [curr.id]: curr.title,
                  }
                : acc.importExport,
              importResult: curr.enableImportResult
                ? {
                    ...acc.importResult,
                    [curr.id]: curr.title,
                  }
                : acc.importResult,
            };
          }, {})
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="program-detail-page">
      {/*<ProgramUploader*/}
      {/*    title='課程'*/}
      {/*    pid={pid}*/}
      {/*/>*/}
      <Card
        title={
          programData.logo ? (
            <div className="with-logo">
              <img src={programData.logo} />
              <div style={{ flex: 1, flexDirection: "row" }}>
                <div>
                  <Text className="program-title">{programData.title}</Text>
                </div>
                <div>
                  <Text className="program-referenceId">
                    {programData.referenceId}
                  </Text>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ flex: 1, flexDirection: "row" }}>
              <div>
                <Text className="program-title">{programData.title}</Text>
              </div>
              <div>
                <Text className="program-referenceId">
                  {programData.referenceId}
                </Text>
              </div>
            </div>
          )
        }
        extra={
          <>
            <Link
              onClick={(e) => e.stopPropagation()}
              to={`${replaceUrlByParams(PAGE.ADMIN_PROGRAM_DETAIL_EDIT, {
                ":pid": pid,
              })}`}
            >
              <EditOutlined /> 編輯
            </Link>
          </>
        }
        cover={
          programData.image ? (
            <div className="cover">
              <img src={programData.image} />
            </div>
          ) : null
        }
      >
        {/*fields*/}
        {/*{*/}
        {/*    programData.fields.map((field, i) => {*/}
        {/*        return (*/}
        {/*            <Descriptions*/}
        {/*                key={field.id}*/}
        {/*                column={2}*/}
        {/*            >*/}
        {/*                <Descriptions.Item label={`查詢欄目 ${i+1}`}>*/}
        {/*                    {field.name}*/}
        {/*                </Descriptions.Item>*/}
        {/*                <Descriptions.Item*/}
        {/*                    label='選填'*/}
        {/*                >*/}
        {/*                    {field.optional ? '是':'否'}*/}
        {/*                </Descriptions.Item>*/}
        {/*            </Descriptions>*/}
        {/*        )*/}
        {/*    })*/}
        {/*}*/}
        <Divider orientation="left">課程設定</Divider>
        <Descriptions>
          <Descriptions.Item label="課程描述">
            <span className="text-area-description">
              {programData.description}
            </span>
          </Descriptions.Item>
        </Descriptions>
        <Descriptions column={3}>
          <Descriptions.Item label="接受付款">
            <Tag color={programData.payment ? "green" : "red"}>
              {programData.payment ? "是" : "否"}
            </Tag>
          </Descriptions.Item>
          {programData.paymentMethod && (
            <Descriptions.Item label="接受付款方式">
              {programData.paymentMethod.map((method, i) => {
                return i > 0
                  ? `/${paymentMethodText(method)}`
                  : paymentMethodText(method);
              })}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="課程狀態">
            <Tag color={programData.activated ? "green" : "red"}>
              {programData.activated ? "進行中" : "已完結"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="報名名額">
            {programData.maxApplicationCount}
          </Descriptions.Item>
          <Descriptions.Item label="課程完結訊息">
            {programData.deactivatedMsg}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions>
          <Descriptions.Item label="收據備註">
            <span className="text-area-description">
              {programData.receiptRemarks}
            </span>
          </Descriptions.Item>
        </Descriptions>
        <Descriptions column={2}>
          <Descriptions.Item label="水印背景" className="receipt-logo">
            <img src={programData.receiptWaterMark} />
          </Descriptions.Item>
          <Descriptions.Item label="收據頁尾">
            {programData.receiptFooter}
          </Descriptions.Item>
        </Descriptions>
        <Divider orientation="left">報名表格</Divider>

        <Descriptions column={2}>
          <Descriptions.Item label="報名狀態">
            <Tag color={programData.enrolmentEnabled ? "green" : "red"}>
              {programData.enrolmentEnabled ? "接受報名" : "已完結"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item contentStyle={{ justifyContent: "flex-end" }}>
            <ImportExportSection pid={pid} sectionIdOption={sectionIdOption} />
          </Descriptions.Item>
        </Descriptions>
        <Descriptions column={3}>
          <Descriptions.Item label="報名完結訊息">
            {programData.enrolmentDisabledMsg}
          </Descriptions.Item>

          <Descriptions.Item label="報名按扭">
            {programData.enrolButton}
          </Descriptions.Item>
          <Descriptions.Item label="標題">
            {programData.resultForm}
          </Descriptions.Item>
          <Descriptions.Item label="查詢按扭">
            {programData.resultSubmitButton}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions>
          <Descriptions.Item label="申請成功標題">
            <span className="text-area-description">
              {programData.applicationSuccessTitle}
            </span>
          </Descriptions.Item>
        </Descriptions>

        <Descriptions>
          <Descriptions.Item label="申請成功描述">
            <span className="text-area-description">
              {programData.applicationSuccessDescription}
            </span>
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <ApplicationList
        sectionIdOption={sectionIdOption}
        applicationCount={programData.applicationCount}
      />
    </div>
  );
}

export default ProgramDetail;
